import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import { ErrorComponent } from '~/components'
import theme from '~/truck/theme'

export const ContentContainer = styled.div`
  background-color: ${theme.colors.white};
  border-radius: ${theme.dimensions.borderRadius}px;
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.comfortable}px;
  width: 100%;

  ${up('lg')} {
    margin: ${theme.spacing.comfortable}px auto 0 auto;
    width: calc(100% - ${theme.spacing.cozy * 4}px);
  }
`

export const InnerContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${up('lg')} {
    flex-direction: row;
  }

  > :first-child {
    margin-bottom: ${theme.spacing.comfortable}px;

    ${up('lg')} {
      margin-bottom: 0;
      margin-right: ${theme.spacing.cozy * 8}px;
    }
  }

  > :first-child * {
    ${up('lg')} {
      max-height: unset;
    }
  }

  > :last-child {
    flex-grow: 1;
  }
`

interface AboutContainerProps {
  clamped: boolean
  showReadMore: boolean
}

export const AboutContainer = styled(ContentContainer)<AboutContainerProps>`
  display: inline-block;

  > :first-child {
    margin-bottom: ${theme.spacing.comfortable}px;
  }
  margin-top: ${theme.spacing.comfortable}px;
  padding-bottom: ${theme.spacing.compact * 13}px;
  position: relative;

  ${({ clamped }) =>
    clamped &&
    `
    overflow: hidden;
    max-height: ${theme.spacing.relaxed * 11}px;
    padding-bottom: ${theme.spacing.compact * 5}px;
  `}

  ${({ clamped, showReadMore }) =>
    clamped &&
    showReadMore &&
    `
    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left:0;
      display: block;
      width: 100%;
      height: ${theme.spacing.comfortable * 10}px;
      background: linear-gradient(0deg, ${
        theme.colors.white
      } 28.48%, rgba(255, 255, 255, 0.5) 68.26%, rgba(255, 255, 255, 0) 100%);
    }
  `}
`

export const StyledErrorComponent = styled(ErrorComponent)`
  align-self: center;
`
